module.exports = __webpack_public_path__ + "img/smile-wink.6b381b76.svg";